import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ArticleSection",
    component: () => (__SERVER__ ? require("./article-section-view") : import("./article-section-view"))
});

export default definition;
